export default __webpack_public_path__ + "static/media/wifi2.9b8351ce.png";